var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 14,
    viewBox: "0 0 55 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_11299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.677 2.05138L44.8237 2.07213V13.7482H42.6367V0H45.6882L52.3348 11.6651L52.1992 11.6969V0H54.3751V13.7482H51.3125L44.677 2.05138Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6104 0H39.7973V13.7482H37.6104V0Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9072 0H30.1359C30.9963 0 31.775 0.146626 32.468 0.438494C33.1694 0.730363 33.7282 1.17716 34.1446 1.78303C34.5609 2.38613 34.7698 3.1649 34.7698 4.11521C34.7698 5.06551 34.5623 5.86088 34.1446 6.50133C33.7282 7.13348 33.1694 7.60933 32.468 7.92748C31.7736 8.24701 30.9963 8.40609 30.1359 8.40609H28.0955V13.7496H25.9086V0H25.9072ZM28.0955 6.61476H29.5328C30.0667 6.61476 30.5536 6.53868 30.9907 6.38652C31.4347 6.22745 31.7861 5.96739 32.0434 5.60498C32.3062 5.24395 32.439 4.76534 32.439 4.16777C32.439 3.56467 32.3062 3.09159 32.0434 2.75131C31.7861 2.40411 31.4347 2.15651 30.9907 2.01265C30.5522 1.86602 30.0667 1.79409 29.5328 1.79409H28.0955V6.61476Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8873 0H23.0742V8.50983C23.0742 9.64134 22.8487 10.6221 22.3964 11.4479C21.9524 12.2668 21.3313 12.8989 20.5318 13.3443C19.7322 13.7828 18.8027 14 17.7404 14C16.6849 14 15.754 13.7814 14.9489 13.3443C14.1439 12.9003 13.5145 12.2682 13.0635 11.4479C12.6126 10.6221 12.3857 9.64134 12.3857 8.50983V0H14.5727V8.39502C14.5727 9.14475 14.7082 9.78658 14.9794 10.3219C15.2574 10.8558 15.6323 11.2653 16.1053 11.5516C16.5839 11.8366 17.1303 11.9791 17.7417 11.9791C18.3531 11.9791 18.894 11.8366 19.3671 11.5516C19.8401 11.2667 20.2109 10.8572 20.4806 10.3219C20.7517 9.78797 20.8873 9.14475 20.8873 8.39502V0Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.05167C5.80832 0 6.49165 0.159075 7.10305 0.478609C7.72137 0.791226 8.21105 1.24909 8.57208 1.85357C8.93311 2.45667 9.11432 3.1898 9.11432 4.05158C9.11432 4.90643 8.95109 5.61051 8.62464 6.16658C8.29819 6.72266 7.90673 7.13902 7.44748 7.41567C6.98824 7.69371 6.5622 7.84863 6.16658 7.88321L9.55143 13.7469H7.08369L3.9589 8.05197H2.18694V13.7496H0V0ZM2.18694 6.46952H4.27013C5.00603 6.46952 5.62435 6.28554 6.1237 5.9176C6.62306 5.54827 6.87343 4.94793 6.87343 4.11659C6.87343 3.27695 6.62721 2.67938 6.13477 2.32526C5.64094 1.97115 5.02678 1.79409 4.29088 1.79409H2.18694V6.46952Z",
    fill: "#334155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_11299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.3733,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupinLogo);
export default __webpack_public_path__ + "static/media/rupinLogo.f0c5a48b77f633459afce874931a0bcc.svg";
export { ForwardRef as ReactComponent };